export const ERROR_FORM_VALIDATION = 'There were one or more errors in your input. Please check the values and try again.';



// WEBPACK FOOTER //
// ./src/constants/messages.js